import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { GroupedOptions } from 'module/types/filter-field/field/grouped-field';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { GroupFieldsMeta } from 'module/types/filter-field/transformer/filter-transformer';
import { useExternalTeamMemberFieldsAsFilterableField } from 'helpers/fields/external-team-members-fields/fields';
import { keyBy } from 'lodash';
import { useMemo } from 'react';

export const useAccountPeopleFieldsForFilter = (): {
  fields: GroupedOptions<FilterableField>[];
  lookups: GroupFieldsMeta;
  isLoading: boolean;
} => {
  const { fields: userFields, loading: isUserFieldsLoading } =
    useExternalTeamMemberFieldsAsFilterableField();
  const userFieldsLookup = useMemo(
    () => keyBy(userFields, 'fieldName'),
    [userFields],
  );
  const translate = useTranslate();
  const fields = useMemo(
    () =>
      asGroupedFieldOptionsForFilter(
        {
          [FilterGroupType.User]: {
            fields: userFields,
          },
        },
        translate,
      ),
    [userFields, translate],
  );
  const lookups: GroupFieldsMeta = useMemo(() => {
    return [
      {
        id: FilterGroupType.User,
        fields: userFieldsLookup,
      },
    ];
  }, [userFieldsLookup]);

  return useMemo(
    () => ({
      isLoading: isUserFieldsLoading,
      fields,
      lookups,
    }),
    [isUserFieldsLoading, fields, lookups],
  );
};
